import { combineReducers } from 'redux';
import routing from './routing';
import basicDetails from './basicDetails'
import uploadDocuments from './uploadDocuments'
import incidentDetails from './incidentDetails';
import referenceData from './referenceData';
import otherDetails from './otherDetails';

export const allSureMotorClaim = combineReducers({
    basicDetails,
    routing,
    uploadDocuments,
    incidentDetails,
    otherDetails,
    referenceData
});
